// src/components/DefaultRedirector.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Adjust path if necessary

const TRAINEE_ROLE_STRING = 'Trainee'; // Define the trainee role string

const DefaultRedirector = () => {
    const { currentUser, userRole, loading } = useAuth(); // Added loading from useAuth

    if (loading) {
        return <div>Loading user information...</div>; // Or your app's loading spinner
    }

    if (!currentUser) {
        // Should be caught by ProtectedRoute, but as a fallback
        return <Navigate to="/login" replace />;
    }

    if (userRole === TRAINEE_ROLE_STRING) {
        return <Navigate to="/trainee-tasks-dashboard" replace />;
    }
    return <Navigate to="/dashboard" replace />;
};

export default DefaultRedirector;